import { gql } from "@apollo/client";

// Section for Create EmployeeEducation
export const CREATE_EMPLOYEEEDUCATION = gql`
  mutation createEmployeeEducation($input: createEmployeeEducationInput) {
    createEmployeeEducation(input: $input) {
      employeeId
    }
  }
`;

// Section for Update Employee Education
export const UPDATE_EMPLOYEEEDUCATION = gql`
  mutation updateEmployeeEducation($input: updateEmployeeEducationInput) {
    updateEmployeeEducation(input: $input)
  }
`;

// Section for Delete EmployeeEducation
export const DELETE_EMPLOYEEEDUCATION = gql`
  mutation deleteEmployeeEducation($Id: Int!) {
    deleteEmployeeEducation(Id: $Id)
  }
`;

// Section for Get Employee Education
export const GET_EMPLOYEEEDUCATION = gql`
  query employeeEducation($employeeId: String!) {
    employeeEducation(employeeId: $employeeId) {
      Id
      employeeId
      name
      degree
      percentage
      certificate
      fieldOfStudy
    }
  }
`;
